// This value is regenerated by scripts/set-build-version.js before each build.
export const buildVersion = '1792131364499';
